// Copyright (c) Move Closer 2022.

import { ComponentsStructureConfig } from '../../../support/mixins'

import { productTabs } from '../../products/config/product-tabs'
import { profileTabItems } from '../../profile/config/profite-tabs'
import { orderTabs } from '../../orders/config/order-tabs'

import { ProfileTabItem } from '../../profile/services/profile-tabs'

import { TabItem } from '../services/tabs'
import { TabOption, tabsItemsLabelRegistry, tabsItemsRouteNamesRegistry } from '../contracts/tabs'
import { loyaltyTabsItems } from '../../loyalty/config/loyalty-tabs'
import { wishlistTabs } from '../../wishlist/config/wishlist-tab'

/**
 * Returns tabs items (shown in ProfileView) based on current application config
 * and provided type of required module
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const pickTabItemsFactory = (config: ComponentsStructureConfig | null, type: TabOption) => {
  if (!config) {
    throw new Error('[tabs.factory.ts] Provided [config] object does not exist!')
  }

  /**
   * @inheritDoc
   */
  checkTypePresence(type)

  /**
   * TODO: navLinks -> modules.navLinks
   */
  if (!config.modules.hasOwnProperty('navLinks')) {
    /**
     * @inheritDoc
     */
    checkTypePresence(type)

    /**
     * Default values for tabs
     */
    switch (type) {
      case TabOption.Loyalty:
        return loyaltyTabsItems
      case TabOption.Products:
        return productTabs
      case TabOption.Profile:
        return profileTabItems
      case TabOption.Orders:
        return orderTabs
      case TabOption.Wishlist:
        return wishlistTabs
    }
  }

  if (!config.modules.navLinks[tabsItemsLabelRegistry[type]]) {
    throw new Error(`[tabs.factory.ts] Provided [config.navLinks] does not have required key of [${tabsItemsLabelRegistry[type]}]! Provide full list of possible keys in appication configuration`)
  }

  /**
   * TODO: navLinks -> modules.navLinks
   * Map navLinks and fill them with proper route name
   */
  return config.modules.navLinks[tabsItemsLabelRegistry[type]].map((tab: Omit<TabItem, 'routeName' | 'value'>): ProfileTabItem => {
    return {
      label: tab.label,
      routeName: tabsItemsRouteNamesRegistry[tab.label],
      priority: tab.priority
    }
  })
}

/**
 * Checks if provided [type] value is contained in available [TabOption] options
 * @param type
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const checkTypePresence = (type: string) => {
  if (!Object.values(TabOption).includes(type as TabOption)) {
    throw new Error('[tabs.factory.ts]: Provided [type] of does not exist in TabOptions!')
  }
}
